import { Button } from '@thanx/uikit/button'
import { Notification } from '@thanx/uikit/notification'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('ordering_management.error_messages')
const cmsT = buildTranslate('cms.components.publish_banner')

type Props = {
  isSaving: boolean
  onPublish: () => void
}

const PublishBanner: React.FC<Props> = ({ isSaving, onPublish }) => (
  <Notification
    kind="info"
    size="full"
    overrides={{
      InnerContainer: { style: { width: '100%' } },
    }}
  >
    <div className="d-flex p-xs align-items-center belize-hole-50">
      <p className="flex-grow-1 body-text-4 mr-m m-0">
        <strong>{cmsT('ready_go_live')}</strong> {cmsT('hit_publish')}
      </p>
      <Button isLoading={isSaving} disabled={isSaving} onClick={onPublish}>
        {t('publish')}
      </Button>
    </div>
  </Notification>
)

export default PublishBanner
